var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetInputBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 443,
    viewBox: "0 0 544 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4101_38713)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 544,
    height: 443,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-272.437 7.95191C-272.421 -47.0159 -245.922 -100.409 -202.866 -134.61C-156.735 -171.253 -96.6113 -187.256 -38.4073 -177.947C21.5824 -168.351 82.4831 -138.721 109.955 -84.5741C135.628 -33.9739 106.013 23.2386 91.4835 78.0673C78.5133 127.013 73.6796 183.219 31.5413 211.337C-10.4579 239.362 -66.6391 232.388 -114.172 215.295C-155.004 200.613 -176.622 161.499 -202.94 127.02C-231.929 89.0408 -272.45 55.7083 -272.437 7.95191Z",
    fill: "#FFD550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.334 166.728C852.152 185.067 893.657 227.849 911.549 279.844C930.718 335.551 925.762 397.571 897.582 449.342C868.537 502.701 820.301 550.241 760.092 558.091C703.828 565.427 659.761 518.433 612.912 486.458C571.09 457.913 519.71 434.619 507.248 385.517C494.827 336.578 520.131 285.935 552.091 246.819C579.546 213.217 623.628 205.875 664.909 192.557C710.38 177.886 755.314 150.795 800.334 166.728Z",
    fill: "#FFD550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4101_38713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 544,
    height: 443,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetInputBg);
export default __webpack_public_path__ + "static/media/assetInput_bg.d9fbcd49cb480dbb45dc41c93290392e.svg";
export { ForwardRef as ReactComponent };